// extracted by mini-css-extract-plugin
export default {"root":"dapps_root__3mAh4","top":"dapps_top__tbR4m","title":"dapps_title__CDO5s","description":"dapps_description__AjX1c","bottom":"dapps_bottom__OtsZu"};